import React from 'react';

export interface PackageOptionsModularContextProps {
    isHideOfferCalendar: boolean;
    isChipOfferOption: boolean;
    isExpandOfferCard: boolean;
}

export const PackageOptionsModularContext = React.createContext<PackageOptionsModularContextProps>({
    isHideOfferCalendar: false,
    isChipOfferOption: false,
    isExpandOfferCard: false,
});

// Create custom hook to be able to mock the context in tests
export const usePackageOptionsModularContext = (): PackageOptionsModularContextProps => {
    return React.useContext(PackageOptionsModularContext);
};

const PackageOptionsModularProvider: React.FC<React.PropsWithChildren<PackageOptionsModularContextProps>> = ({ children, ...props }) => {
    return <PackageOptionsModularContext.Provider value={props}>{children}</PackageOptionsModularContext.Provider>;
};

PackageOptionsModularProvider.displayName = 'PackageOptionsModularProvider';

export { PackageOptionsModularProvider };
